/**
 * Kullanıcının kendi "Çıkış yap" isteğini, kendiliğinden düşen oturumdan ayırır.
 *
 * NEDEN VAR (GUNUM-VAR-1R): Supabase iki durumda da aynı `SIGNED_OUT` olayını
 * veriyor. Sentry'deki 4 uyarının 3'ü kullanıcının kendi çıkışıydı; gerçek oturum
 * kaybı bunların arasında kayboluyordu.
 *
 * İşaret tek kullanımlıktır: ilk `SIGNED_OUT` onu tüketir.
 */
let intentional = false

export function markIntentionalSignOut(): void {
  intentional = true
}

export function consumeIntentionalSignOut(): boolean {
  const was = intentional
  intentional = false
  return was
}
